import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';

import { Grid, Card, CardContent, TextField, CardHeader, Divider, Tooltip } from '@material-ui/core';
import { Icon, IconButton } from '@material-ui/core';
import Note from './Note';

class NoteList extends Component {
    state = {
        table_name: '',
        table_id: 0,
        is_dialog_open: false,
        current_note_id: 0,
    }
    
    constructor(props) {
        super(props);
        
        this.state.table_name  = this.props.table_name || '';
        this.state.table_id    = this.props.table_id   || 0;
    }

    handleDialogOpen = (note_id) => {
        this.setState({
            ...this.state,
            is_dialog_open: !this.state.is_dialog_open,
            current_note_id: note_id,
        });
    }

    // Given a table_name and table_id, will return array of related Notes
    getAssociatedNotes = (table_name, table_id) => {
        const { noteList } = this.props;

        return noteList.filter((note) => {
            if (note.relationList.length > 0) {
                let is_related = false;

                note.relationList.forEach((note_relation) => {
                    if(note_relation.NoteReference === table_name && note_relation.NoteReferenceID === table_id) {
                        is_related = true;
                    }
                });

                return is_related;
            }

            return false;
        });
    }

    getCardActions = (subsetNoteList) => {
        if(this.props.type === 'student') return (<React.Fragment></React.Fragment>)
        
        if (subsetNoteList.length > 0) {
            let note = subsetNoteList[0];

            return (
                <React.Fragment>
                    <Tooltip title="Delete Note" placement="top">
                        <IconButton
                            onClick={() => this.props.deleteNote(note.header.note_id)}
                        >
                            <Icon style={{ color: 'red' }}>remove_circle_outline</Icon>
                        </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Edit Note" placement="top">
                        <IconButton
                            onClick={() => this.handleDialogOpen(note.header.note_id)}
                        >
                            <Icon>subject</Icon>
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <Tooltip title="Add Note" placement="top">
                        <IconButton
                            onClick={() => this.handleDialogOpen(0)}
                        >
                            <Icon style={{ color: 'green' }}>add_comment</Icon>
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
            );
        }
    }
    
    render() {
        const { noteList } = this.props;
        const subsetNoteList = this.getAssociatedNotes(this.state.table_name, this.state.table_id);
        const cardActions = this.getCardActions(subsetNoteList);

        if (typeof noteList === 'undefined') {
            return <React.Fragment>Loading...</React.Fragment>
        }

        return (
            <React.Fragment>
                <Note
                    note_id={this.state.current_note_id}
                    open={this.state.is_dialog_open}
                    onClose={this.handleDialogOpen}
                    table_name={this.state.table_name}
                    table_id={this.state.table_id}
                />
                <Card>
                    <CardHeader
                        action={cardActions}
                        title="Instructor Note"
                        subheader={<Divider />}
                    />
                    <CardContent>
                        <Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={
                                        subsetNoteList.length > 0
                                        ? subsetNoteList[0].header.Description
                                        : ''
                                    }
                                    variant="outlined"
                                    multiline={true}
                                    fullWidth={true}
                                    rows={3}
                                    disabled
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearNote:       Actions.clearNote,
        getNote:         Actions.getNote,
        saveNote:        Actions.saveNote,
        updateNote:      Actions.updateNote,
        setNoteLoaded:   Actions.setNoteLoaded,
        deleteNote:      Actions.deleteNote,
        viewNote:        Actions.viewNote
    }, dispatch);
}

function mapStateToProps({ note }) {
    return {
        noteList: note.note.noteList,
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NoteList)));


// WEBPACK FOOTER //
// src/main/components/note/NoteInfo.js